import { useState, useEffect } from "react";
import * as All from "react-icons/md/index";
import ClickAwayListener from "react-click-away-listener";
export default function Icon({ value, onChange, params }) {
  const [_value, setValue] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (value) {
      setValue([All[value]]);
      console.log(All[value]);
    }
  }, [value]);

  const handleSelect = (v) => {
    setValue([v]);
    onChange(v.name);
    setOpen(false);
  };

  if (!_value) {
    return <div />;
  }
  return (
    <div style={{ position: "relative" }}>
      {_value.map((I) => {
        return (
          <I
            style={{ fontSize: 24 }}
            onClick={() => setOpen(true)}
            key={I.name}
          />
        );
      })}
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div
            style={{
              width: 280,
              padding: 10,
              backgroundColor: "white",
              borderRadius: 5,
              top: 24,
              left: 0,
              position: "absolute",
              height: 300,
              zIndex: 5,
              overflowY: "scroll",
              boxSizing: "border-box",
              boxShadow: "0px 2px 12px 2px rgba(0,0,0,.3)",
            }}
          >
            {Object.keys(All).map((K) => {
              const Item = All[K];
              return (
                <Item
                  onClick={() => handleSelect(Item)}
                  style={{
                    fontSize: 18,
                    margin: 4,
                    color: "#333",
                    cursor: "pointer",
                  }}
                />
              );
            })}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}
